import jwtDecode from 'jwt-decode';

import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  TOKEN_EXPIRATION_TIME,
  LAST_REQUEST_DATE,
  EXTERNAL_ACCESS_TOKEN,
  MFA_TOKEN,
  TEMP_CLEAR,
} from 'src/types';
import { USER_AUTH_TYPE } from 'src/types'; // TODO:autenticação antiga

const authStorage = {
  isValidToken(accessToken) {
    if (!accessToken) {
      return false;
    }

    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  },

  tokenHasLanguage(accessToken) {
    const decodedToken = jwtDecode(accessToken);
    const hasLanguage = decodedToken.idioma != null;
    return hasLanguage;
  },

  isConsultaExternaAllowed(accessToken) {
    if (!accessToken) return true;

    try {
      const decodedToken = jwtDecode(accessToken);
      const hasExternoClaim =
        decodedToken?.['stratec:acessoExterno'] === true ||
        decodedToken?.['stratec:acessoExterno']?.toString().toLowerCase() ===
          'true';

      const pathname = window.location.pathname;

      const isConsultaExternaRoute =
        pathname === '/consulta-externa' ||
        pathname.startsWith('/consulta-externa/');

      if (hasExternoClaim && !isConsultaExternaRoute) {
        return false;
      }

      return true;
    } catch (err) {
      console.error('Erro ao decodificar token:', err);
      return false;
    }
  },

  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN);
  },

  getMFAToken() {
    return localStorage.getItem(MFA_TOKEN);
  },

  getRefresToken() {
    return localStorage.getItem(REFRESH_TOKEN);
  },

  getTokenExpirationTime() {
    return localStorage.getItem(TOKEN_EXPIRATION_TIME);
  },

  getExternalAccessToken() {
    return localStorage.getItem(EXTERNAL_ACCESS_TOKEN);
  },

  removeAccessToken() {
    return localStorage.removeItem(ACCESS_TOKEN);
  },

  removeRefreshToken() {
    return localStorage.removeItem(REFRESH_TOKEN);
  },

  removeTokenExpirationTime() {
    return localStorage.removeItem(TOKEN_EXPIRATION_TIME);
  },

  removeExternalAccessToken() {
    return localStorage.removeItem(EXTERNAL_ACCESS_TOKEN);
  },

  setAccessToken(token) {
    if (token) {
      localStorage.setItem(ACCESS_TOKEN, token);
    } else {
      localStorage.removeItem(ACCESS_TOKEN);
    }
  },

  setMFAToken(token) {
    if (token) {
      localStorage.setItem(MFA_TOKEN, token);
    }
  },

  setRefreshToken(token) {
    if (token) {
      localStorage.setItem(REFRESH_TOKEN, token);
    } else {
      localStorage.removeItem(REFRESH_TOKEN);
    }
  },

  setTokenExpirationTime(time) {
    if (time) {
      localStorage.setItem(TOKEN_EXPIRATION_TIME, time);
    } else {
      localStorage.removeItem(TOKEN_EXPIRATION_TIME);
    }
  },

  setLastRequestDate() {
    const accessToken = this.getAccessToken();
    if (this.isValidToken(accessToken)) {
      localStorage.setItem(LAST_REQUEST_DATE, Date());
    }
  },

  setExternalAccessToken(token) {
    if (token) {
      localStorage.setItem(EXTERNAL_ACCESS_TOKEN, token);
    } else {
      localStorage.removeItem(EXTERNAL_ACCESS_TOKEN);
    }
  },

  getLastRequestDate() {
    try {
      const dataUltimaRequisicao = localStorage.getItem(LAST_REQUEST_DATE);
      if (dataUltimaRequisicao) return new Date(dataUltimaRequisicao);
    } catch (error) {
      return new Date(1901, 1, 1);
    }

    const accessToken = this.getAccessToken();
    if (this.isValidToken(accessToken)) {
      localStorage.setItem(LAST_REQUEST_DATE, Date());
    }
  },

  // TODO:autenticação antiga
  setAuthType(authType) {
    localStorage.setItem(USER_AUTH_TYPE, JSON.stringify(authType));
  },

  // TODO:autenticação antiga
  getAuthType() {
    try {
      const authType = localStorage.getItem(USER_AUTH_TYPE);
      return JSON.parse(authType);
    } catch (error) {
      return 0;
    }
  },

  clearAllStorage() {
    const BYPASS_FULL_LOGOUT = false; // Altere para true para forçar o logout para todos os domínios
    const CURRENT_CLEAR_DATE = '2026-07-28'; // Atualize essa data para forçar logout novamente
    const SUBDOMAINS_TO_LOGOUT = ['sbshsl'];

    const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0];

    // Recupera a data salva no localStorage
    const storedDate = localStorage.getItem(TEMP_CLEAR);

    // Checa se o subdomínio está na lista ou se o bypass está ativado
    const isTarget = SUBDOMAINS_TO_LOGOUT.includes(subdomain);

    // Se o bypass estiver ativo, não precisamos validar o subdomínio
    // Executamos o clear se o armazenamento estiver vazio ou o valor for diferente do CURRENT_CLEAR_DATE.
    const shouldClear =
      (BYPASS_FULL_LOGOUT || isTarget) &&
      (!storedDate || storedDate !== CURRENT_CLEAR_DATE);

    if (shouldClear) {
      localStorage.clear();
      localStorage.setItem(TEMP_CLEAR, CURRENT_CLEAR_DATE);
    }
  },
};

export default authStorage;
